import type { ReactNode } from "react";
import React from "react";
import { Row } from "reactstrap";
import TableWrapper from "@/utils/TableWrapper";
type DisplayPropertiesViewProps = {
  alert: ReactNode;
  columns: unknown[];
  reformattedProp: unknown[];
};

export default function DisplayPropertiesView({
  alert,
  columns,
  reformattedProp,
}: DisplayPropertiesViewProps) {
  return (
    <>
      {/* SweetAlert */}
      {alert}
      <Row>
        <TableWrapper data={reformattedProp} columns={columns} />
      </Row>
    </>
  );
}
